<template>
  <AffiliateRecipesPage />
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import AffiliateRecipesPage from '@/components/AffiliateRecipes.vue'

export default {
  name: 'AffiliateRecipes',
  components: {
    AffiliateRecipesPage
  }
}
</script>
